<template>
  <div class="eu-display_flex eu-align-items_center eu-width_100">
    <div class="emd-form-group eu-pt_3 eu-pb_2 eu-width_100">
      <input
        v-model="copiable"
        disabled
        class="emd-input"
        type="text"
      />
    </div>
    <div
      v-if="!viewCopy"
      class="emd-tip _hoverble eu-mx_1"
    >
      <div class="emd-tip__container">
        <div
          class="emd-tip__box _color_contrast _arrow_top _position_bottom _no_shadow eu-mt_2 eu-ml_2"
        >
          {{ label }}
        </div>
      </div>
      <button
        class="emd-action-button header-button"
        @click="handleClicked"
      >
        <emerald-icon
          icon="copy"
          data-testid="button-copy"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { EmeraldIcon } from 'emerald-vue/src/components'

export default {
  name: 'CopyClipboard',
  components: {
    EmeraldIcon
  },

  props: {
    copiable: String,
    secondaryButtons: Boolean,
    viewCopy: Boolean
  },

  data () {
    return {
      label: this.$t('general.copy')
    }
  },

  methods: {
    handleClicked () {
      this.$copyText(this.copiable).then(() => {
        this.label = this.$t('general.copied')
        this.$emit('handleCopied', true)
      })
    }
  }
}
</script>
